import { IoMdLocate } from "react-icons/io";
import { isMobile, isTablet } from 'react-device-detect';
import { FaRegFilePdf } from "react-icons/fa6";

const GenPDF = ({
    globalRefs,
    globalState,
}) => {

    let polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;
    let setIsCreatingPDF = globalState.setIsCreatingPDF;

    const beginPDFGen = ()  => {
        setIsCreatingPDF(true);
    }

    return (
        <div className={`genpdf`}>
            <button
                onClick={() => {
                    beginPDFGen();
                }}
            >
                {isMobile ? <FaRegFilePdf style={{color: "#073029"}} className="genpdfIcon" size={18} /> :
                    <>
                        <FaRegFilePdf style={{color: "#073029"}} className="genpdfIcon" size={18} />
                    </>}

            </button>
        </div>
    );
}

export default GenPDF;
